import { render, staticRenderFns } from "./Housing.vue?vue&type=template&id=1ef82ef6&scoped=true&"
import script from "./Housing.vue?vue&type=script&lang=js&"
export * from "./Housing.vue?vue&type=script&lang=js&"
import style0 from "./Housing.vue?vue&type=style&index=0&id=1ef82ef6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef82ef6",
  null
  
)

export default component.exports